<template>
  <div>
    <!--<div class="LanguageSwitcher">
      <a href="#" @click.prevent="setLocale('FR')"><img src="../assets/FR.jpg" class="drapeau"/></a>
      <a href="#" @click.prevent="setLocale('EN')"><img src="../assets/EN.jpg" class="drapeau"/></a>
      <a href="#" @click.prevent="setLocale('DE')"><img src="../assets/DE.jpg" class="drapeau"/></a>
      <a href="#" @click.prevent="setLocale('NL')"><img src="../assets/NL.jpg" class="drapeau"/></a>
    </div>-->

      <!--<select v-model="$i18n.locale" style="background-color:#cc0000;border:none;color:#fff">
        <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang" @click.prevent="setLocale('Lang${i}')">{{lang}}</option>
      </select>-->
      <!--<select v-model="$i18n.locale" style="background-color:#cc0000;border:none;color:#fff" v-on:change="setLocale($i18n.locale)">
        <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">{{lang}}</option>
      </select>-->

    <div class="wrapper">
      <div @click="toggle" class="btn">{{ actualLang }}  <img src="../assets/liste_deroulante2.png" style="width:15px;"/></div>
      <div v-show=isOpen style="position:absolute;z-index:1000000" class="content">
        <ul class="list">
          <li><a href="#" @click.prevent="setLocale('DE')">DE</a></li>
          <li><a href="#" @click.prevent="setLocale('EN')">EN</a></li>
          <li><a href="#" @click.prevent="setLocale('FR')">FR</a></li>
          <li><a href="#" @click.prevent="setLocale('NL')">NL</a></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      langs : ['FR', 'EN', 'DE', 'NL'],
      isOpen: false,
      actualLang: this.$i18n.locale,
      detectLang: false,
    }
  },
  methods: {
    setLocale(locale){
      if (this.$i18n.locale !== locale){
        this.$i18n.locale = locale
        this.actualLang = locale
        this.$router.push({
          params: { lang: locale }
        })
        this.$router.go(0);
      }
    },
    toggle() {
      this.isOpen = !this.isOpen;
    }
  },
  /*created() {
    // initialiation de la langue du navigateur
    if(this.detectLang == false){
      let browserLang = window.navigator.language || window.navigator.userLanguage
      alert(browserLang)
      if (browserLang.indexOf('fr') > -1) {
          this.setLocale('FR')
      } else if (browserLang.indexOf('en') > -1) {
          this.setLocale('EN')
      } else if (browserLang.indexOf('nl') > -1) {
          this.setLocale('NL')
      } else if (browserLang.indexOf('deS') > -1) {
          this.setLocale('DE')
      } else {
        this.setLocale('EN')
      }
      this.detectLang = true
    }
  }*/
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
